import { merge } from "remeda";
import { MOSTRAR_MENSAJE } from "../actionTypes";

const initial = {
  mensaje: "",
  tipo: "",
  open: false,
};

const snackBar = (state = initial, action) => {
  switch (action.type) {
    case MOSTRAR_MENSAJE:
      return merge(state, action.payload);
    default:
      return state;
  }
};

export default snackBar;
